import { CSSProperties, FC, ReactNode, useCallback, useEffect } from 'react';
import Modal from 'react-modal';
import cx from 'classnames';

import { SvgIcon } from '@/components/SvgIcon';

import styles from './ModalInfo.module.sass';

const modalStyles = {
  content: {
    inset: 0,
    border: 'none',
    backgroundColor: 'transparent',
    pointerEvents: 'none',
  } as CSSProperties,
};

export interface ModalInfoProps {
  isOpen: boolean;
  canClose?: boolean;
  title?: string | null;
  children?: ReactNode;
  actions?: ReactNode;
  isShowCloseButton?: boolean;
  className?: string;

  onClose?: () => void;
}

const ModalInfo: FC<ModalInfoProps> = ({
  isOpen,
  canClose = true,
  title,
  children,
  actions,
  isShowCloseButton = true,
  className,
  onClose,
}) => {
  const handleOnClose = useCallback(() => {
    if (canClose) {
      onClose?.();
    }
  }, [canClose, onClose]);

  const classes = cx(styles.modal, className);

  return (
    <Modal
      isOpen={isOpen}
      className="modal-content"
      bodyOpenClassName={styles.bodyLock}
      overlayClassName="modal-overlay modal-overlay--black"
      ariaHideApp={false}
      style={modalStyles}
      onRequestClose={handleOnClose}
    >
      <div className={classes}>
        {title && <div className={styles.title}>{title}</div>}
        {children}
        {actions && <div className={styles.actions}>{actions}</div>}
        {isShowCloseButton && (
          <button
            type="button"
            className={styles.close}
            onClick={handleOnClose}
          >
            <SvgIcon name="x" />
          </button>
        )}
      </div>
    </Modal>
  );
};

export default ModalInfo;
